import React from "react";
import { Button, Modal, Paper, Stack } from "@mui/material";
import styled from "styled-components";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";
import { useAuth } from "src/components/providers/auth-context";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

const H = styled.h1`
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.secondary.main};
    margin: 0;
`;

const P = styled.p`
    font-size: 12px;
    font-weight: 300;
    min-height: 56px;
    max-width: 95%;
    color: ${({ theme }) => theme.palette.secondary.main};
    padding-bottom: 16px;
    margin: 0;
`;

const RevokeTokenModal = ({ open, handleClose, setLoading, setOrganizationToken }) => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const { isDemo } = useAuth();

    const getOrganizationToken = async () => {
        let response;
        if (isDemo) {
            response = null;
        } else {
            response = await request(`api/users/token`, { method: "GET" });
        }
        setOrganizationToken(response);
        setLoading(false);
    };

    const revokeAction = async () => {
        await request(`/api/users/token`, { method: "DELETE" });
        setMessage(`You have successfully revoked organization token`);
        setSeverity("success");
        setIsToastTriggered(true);
        setLoading(true);
        getOrganizationToken();
        handleClose();
    };

    const handleRevoke = async () => {
        try {
            revokeAction();
        } catch (e) {
            setMessage(`Error aborting mission. Please try again.`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Paper sx={style}>
                <H id="modal-modal-title" variant="h6" component="h2">
                    Revoke access token
                </H>
                <P id="modal-modal-description" sx={{ mt: 2 }}>
                    This action is irreversible and the consequences dire. Please think this through
                    before proceeding.
                </P>
                <Stack
                    direction="row"
                    justifyContent="flex-end"
                    spacing={2}
                    style={{ width: "100%" }}
                >
                    <Button color="secondary" size="medium" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="warning"
                        size="medium"
                        onClick={handleRevoke}
                    >
                        Revoke
                    </Button>
                </Stack>
            </Paper>
        </Modal>
    );
};

export default RevokeTokenModal;
